import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckOutPrintInvoice from "../../../RoomCheckOut/Componates/CheckOutPrintInvoice";
import Spinner from "Common/Globle/Spinner";

const InvoicePrint = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [printed, setPrinted] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const mediaQuery = window.matchMedia("print");

        const handlePrint = (e) => {
            if (!e.matches) {
                navigate("/check-in/");
            }
        };

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener("change", handlePrint);
        } else {
            mediaQuery.addListener(handlePrint);
        }

        return () => {
            if (mediaQuery.removeEventListener) {
                mediaQuery.removeEventListener("change", handlePrint);
            } else {
                mediaQuery.removeListener(handlePrint);
            }
        };
    }, [navigate]);

    const handleLoaded = () => {
        setLoading(false);

        if (printed) return;

        setPrinted(true);

        setTimeout(() => {
            window.print();
        }, 500);
    };

    return (
        <>
            {loading && <Spinner isSpinner={true} />}

            <div
                className={`${loading ? "d-none" : "d-none d-print-block print-invoice-wrapper"}`}
            >
                <CheckOutPrintInvoice
                    id={id}
                    onLoaded={handleLoaded}
                />
            </div>
        </>
    );
};

export default InvoicePrint;